import axios from 'axios';
import { clearAdminToken, getAdminToken } from '../utils/adminAuth';

const healthHouseConnectorsApi = axios.create({
  baseURL: '/api/v1/health-house/connectors',
  withCredentials: true
});

healthHouseConnectorsApi.interceptors.request.use(
  (config) => {
    const token = getAdminToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

healthHouseConnectorsApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      clearAdminToken();
      if (typeof window !== 'undefined') {
        window.location.href = '/web/admin-login';
      }
    }
    return Promise.reject(error);
  }
);

export const listHealthHouseConnectors = async () => {
  const response = await healthHouseConnectorsApi.get('');
  return response.data;
};

export const createHealthHouseConnector = async (payload) => {
  const response = await healthHouseConnectorsApi.post('', payload);
  return response.data;
};

export const patchHealthHouseConnector = async (id, payload) => {
  const response = await healthHouseConnectorsApi.patch(`/${id}`, payload);
  return response.data;
};

export const deleteHealthHouseConnector = async (id) => {
  const response = await healthHouseConnectorsApi.delete(`/${id}`);
  return response.data;
};

export const rotateHealthHouseConnectorToken = async (id, payload) => {
  const response = payload
    ? await healthHouseConnectorsApi.post(`/${id}/rotate-token`, payload)
    : await healthHouseConnectorsApi.post(`/${id}/rotate-token`);
  return response.data;
};

export default healthHouseConnectorsApi;
